<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id="addGnbReportTemplateDialog">
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.templateName')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" name="templateName" type="text" v-model="templateName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.resourceType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource="dataSourceOfNeType" :fields="fieldsOfNeType" v-model="neTypeCode" :change="neTypeChange"></ejs-dropdownlist>
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.paramType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource="dataSourceOfParamType" :fields="fieldsOfParamType" v-model="paramTypeCode" :change="paramTypeChange"></ejs-dropdownlist>
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.counterSpace')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <ejs-dropdownlist :dataSource="dataSourceOfSpace" :fields="fieldsOfSpace" v-model="spaceCode" :change="spaceChange"></ejs-dropdownlist>
            </div>
          </div>
        </div>
        <div class='col-sm-6'>
          <div class="h-col-inputBox-right">
            <div class="h-inputLit">{{$t('Pm.chooseCounters')}}</div>
            <ejs-treeview
              ref='gnbPmReportTemplateTree'
              :expandedNodes='expandedNodes'
              :fields='fieldsOfGnbPmReportTemplateTree'
              :showCheckBox='true'
              :nodeChecked="gnbPmTemplateAddTreeNodeChecked"
            ></ejs-treeview>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

  import {FormValidator} from "@syncfusion/ej2-vue-inputs";

  export default {
    name: 'AddGnbReportTemplate',
    components: {
    },
    data() {
      return {
        dataSourceOfNeType: [],
        dataSourceOfParamType: [],
        dataSourceOfSpace: [],
        fieldsOfNeType: {
          text: 'neTypeName',
          value: 'neTypeCode'
        },
        fieldsOfParamType: {
          text: 'paramTypeName',
          value: 'paramTypeCode'
        },
        fieldsOfSpace: {
          text: 'spaceName',
          value: 'spaceCode'
        },
        templateName: '',
        neTypeCode: '',
        neTypeName: '',
        paramTypeCode: '',
        paramTypeName: '',
        spaceCode: '',
        spaceName: '',
        systemCounterList: {},
        customCounterList: {},
        expandedNodes: ['root'],
        fieldsOfGnbPmReportTemplateTree: {
          dataSource: [],
          id: 'id',
          parentID: 'parentId',
          text: 'name',
          hasChildren: 'hasChildren',
          expanded: 'expanded'
        },
        addTemplateValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            templateName: {
              required: [true, this.$t('Pm.taskNameNull')],
              regex: [/^[^\'\\\"\<\>]+$/, this.$t('Pm.onlyNumAndLetter')],
              maxLength: [60, this.$t('Pm.taskNameOver60')]}
          }
        },
        formObjOfAddTemplate: ''
      }
    },
    methods: {
      async init(){
        await this.getNeTypeListAsync();
        await this.getParamTypeListAsync();
        await this.getSpaceListAsync();
        await this.getCounterListAsync();
      },

      async getNeTypeListAsync(){
        await this.$axios.get('/lte/ems/pm/gnb/report/template/getNeTypeList.html').then((response) => {
          this.dataSourceOfNeType = response.data.resultVal;
          this.neTypeCode = response.data.resultVal[0].neTypeCode;
          this.neTypeName = response.data.resultVal[0].neTypeName;
        });
      },

      async getParamTypeListAsync(){
        await this.$axios.get('/lte/ems/pm/gnb/report/template/getParamTypeList.html').then((response) => {
          this.dataSourceOfParamType = response.data.resultVal;
          this.paramTypeCode = response.data.resultVal[0].paramTypeCode;
        });
      },

      async getSpaceListAsync(){
        await this.$axios.get(`/lte/ems/pm/gnb/report/template/getSpaceList.html?paramTypeCode=${this.paramTypeCode}`).then((response) => {
          this.dataSourceOfSpace = response.data.resultVal;
          this.spaceCode = response.data.resultVal[0].spaceCode;
        });
      },

      async getCounterListAsync(){
        await this.$axios.get(`/lte/ems/pm/gnb/report/template/getCounterList.html?paramTypeCode=${this.paramTypeCode}&spaceCode=${this.spaceCode}`).then((response) => {
          this.fieldsOfGnbPmReportTemplateTree = {
            dataSource: response.data.resultVal,
            id: 'id',
            parentID: 'parentId',
            text: 'name',
            hasChildren: 'hasChildren',
            expanded: 'expanded'
          };
        });
      },

      neTypeChange(msg){

      },

      paramTypeChange(msg){
        let paramTypeCodeValue = msg.value;
        this.paramTypeName = msg.itemData.paramTypeName;
        this.$axios.get(`/lte/ems/pm/gnb/report/template/getSpaceList.html?paramTypeCode=${paramTypeCodeValue}`).then((response) => {
          this.dataSourceOfSpace = response.data.resultVal;
          this.spaceCode = response.data.resultVal[0].spaceCode;
          this.getCounterListAsync();
        });
      },

      spaceChange(msg){
        this.spaceName = msg.itemData.spaceName;
        this.getCounterListAsync();
      },

      gnbPmTemplateAddTreeNodeChecked(args){
        console.log('args',args);
        const checkStatus = args.action;
        if(checkStatus == "check"){
          for(let checkedNode of args.data){
            if(checkedNode.hasChildren == false){
              if(checkedNode.parentID == "system"){
                this.systemCounterList[checkedNode.id] = checkedNode.text;
              }else{
                this.customCounterList[checkedNode.id] = checkedNode.text;
              }
            }
          }
        }else if(checkStatus == 'uncheck'){
          for(let checkedNode of args.data){
            if(checkedNode.parentID == "system" && this.systemCounterList[checkedNode.id] != null && this.systemCounterList[checkedNode.id] != undefined ){
              delete this.systemCounterList[checkedNode.id];
            }else if(checkedNode.parentID == "custom" && this.customCounterList[checkedNode.id] != null && this.customCounterList[checkedNode.id] != undefined){
              delete this.customCounterList[checkedNode.id];
            }
          }
        }
      },
      bindValidateOfAddTemplate() {
        this.formObjOfAddTemplate = new FormValidator('#addGnbReportTemplateDialog', this.addTemplateValidation);
      },

      validateOfAddTemplate() {
        const formStatus = this.formObjOfAddTemplate.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },
    },
    mounted() {
      this.init();
      this.bindValidateOfAddTemplate();
    }
  }
</script>

<style scoped>
</style>
